module.exports = __webpack_public_path__ + "4e65e214a3bbe510c9e37f58c91382bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11-small.jpg
// module id = DrC8
// module chunks = 0